module.exports = __webpack_public_path__ + "static/media/excel-white.88a14547.svg";